const PartialSuccessIcon = () => {
    return (
        <div className={'partials PartialSuccessIcon'}>
            <span className="bg-green-600 mb-10 verifiedIconContainer">
                <span className={"icon icon-checkmark text-white"}></span>
            </span>
        </div>
    )
}

export default PartialSuccessIcon;
